import { Navigate, useParams, useRoutes } from "react-router-dom";

function RedirectOrder() {
  const { solution_key, solution_type, size } = useParams();
  const path = size
    ? `/order/${solution_key}/${solution_type}/${size}`
    : `/order/${solution_key}/${solution_type}`;
  return <Navigate to={path} replace />;
}

function RedirectSolutions() {
  const { category_key } = useParams();
  return <Navigate to={`/solutions/${category_key}`} replace />;
}

function RedirectCategories() {
  const { field_key } = useParams();
  return <Navigate to={`/categories/${field_key}`} replace />;
}

function RedirectProfile() {
  const { options } = useParams();
  return <Navigate to={options ? `/profile/${options}` : "/profile"} replace />;
}

function FixiterRoutes() {
  const fixiterLegacyRoutes = useRoutes([
    {
      path: "/fixiter/dashboard",
      element: <Navigate to="/dashboard" replace />,
    },
    {
      path: "/fixiter/courses",
      element: <Navigate to="/courses" replace />,
    },
    {
      path: "/fixiter/certificate",
      element: <Navigate to="/certificate" replace />,
    },
    {
      path: "/fixiter/profile/:options",
      element: <RedirectProfile />,
    },
    {
      path: "/fixiter/categories/:field_key",
      element: <RedirectCategories />,
    },
    {
      path: "/fixiter/solutions/:category_key",
      element: <RedirectSolutions />,
    },
    {
      path: "/fixiter/order/:solution_key/:solution_type",
      element: <RedirectOrder />,
    },
    {
      path: "/fixiter/order/:solution_key/:solution_type/:size",
      element: <RedirectOrder />,
    },
    {
      path: "/fixiter/onboard",
      element: <Navigate to="/dashboard" replace />,
    },
  ]);

  return fixiterLegacyRoutes;
}

export default FixiterRoutes;
